import styled from 'styled-components'

export const Title = styled('div')`
  font-size: 22px;
  margin-bottom: 16px;
  font-weight: 700;
`
